module.exports = __webpack_public_path__ + "img/img-5.f2d58877.png";